import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import {
  OnBoardingVideoRepository,
  ON_BOARDING_VIDEO_REPOSITORY
} from '@app/domain/repositories/on-boarding-video.repository.contract';
import { OnBoardingType, OnBoardingVideoType } from '@app/entities/interfaces/user/user-onboarding.interface';
import { OnBoardingVideo } from '@app/entities/models/on-boarding-video/on-boarding-video.model';

import { OnBoardingVideoUseCases } from './on-boarding-video.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class OnBoardingVideoUseCasesImpl implements OnBoardingVideoUseCases {
  #onBoardingVideoRepository: OnBoardingVideoRepository = inject(ON_BOARDING_VIDEO_REPOSITORY);

  getOnBoardingVideo(
    companyCode: string,
    type: OnBoardingType,
    videoType: OnBoardingVideoType
  ): Observable<OnBoardingVideo[]> {
    return this.#onBoardingVideoRepository.getOnBoardingVideo(companyCode, type, videoType);
  }
}
